'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = require('glamor');

var _Box = require('./Box');

var _Box2 = _interopRequireDefault(_Box);

var _TextStyles = require('./TextStyles');

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

var _splitProps2 = require('./utils/splitProps');

var _splitProps3 = _interopRequireDefault(_splitProps2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var minorScale = _theme2.default.minorScale,
    majorScale = _theme2.default.majorScale;


var labelStyles = (0, _glamor.css)({
  cursor: 'pointer'
});

var inputStyles = (0, _glamor.css)({
  left: 0,
  opacity: 0,
  position: 'absolute',
  top: 0,
  zIndex: -1,
  '&:disabled + span': {
    backgroundColor: _theme2.default.colors.borderColor
  },
  '&:checked + span::before': {
    content: '""',
    position: 'absolute',
    height: '6px',
    width: '6px',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '50%',
    display: 'block',
    backgroundColor: _theme2.default.colors.activeColor
  }
});

var controlStyles = (0, _glamor.css)({
  position: 'relative',
  top: '3px',
  height: majorScale(2),
  width: majorScale(2),
  borderRadius: '50%',
  boxShadow: 'inset 0 0 0 1px ' + _theme2.default.colors.borderColor,
  display: 'inline-block',
  marginRight: minorScale(3)
});

var Radio = function Radio(_ref) {
  var className = _ref.className,
      label = _ref.label,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['className', 'label', 'children']);

  // Tries to treat this component as a single box
  var _splitProps = (0, _splitProps3.default)(props, /margin|width|height|display|position/gi),
      matchedProps = _splitProps.matchedProps,
      unmatchedProps = _splitProps.unmatchedProps;

  return _react2.default.createElement(
    _Box2.default,
    _extends({ is: 'label' }, matchedProps, labelStyles),
    _react2.default.createElement('input', _extends({ type: 'radio' }, inputStyles, unmatchedProps)),
    _react2.default.createElement('span', controlStyles),
    _react2.default.createElement(
      _TextStyles.Body1,
      { is: 'span' },
      children
    )
  );
};

Radio.propTypes = {
  children: _propTypes2.default.string,
  name: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.string.isRequired,
  label: _propTypes2.default.string
};

Radio.defaultProps = {
  marginY: majorScale(1),
  position: 'relative',
  display: 'block'
};

Radio.displayName = 'Radio';

exports.default = Radio;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/Radio.js
// module id = 1127
// module chunks = 0